import { defineStore } from 'pinia'

interface LoaderInterface {
  loading: boolean
}

export const useLoaderStore = defineStore('loader', {
  state: (): LoaderInterface => {
    return {
      loading: false,
    }
  },
  actions: {
    setLoader(value: boolean): void {
      this.loading = value
    },
  },
  getters: {
    getLoader(state): boolean {
      return state.loading
    },
  },
})
